import { AnyEventObject } from 'xstate';
import { patchData, postData } from '~/utils/service';
import { Scope } from './types';

const ROUTE_NAME = 'msaasDetails';

export const API_CALLS = {
  create: async ({ input }: { input: Scope }) => {
    const event = input.event as AnyEventObject;
    const dataToSend = {
      ...event.payload.values,
      endDate: event.payload.values.endDate || null,
      laborReqType: event.payload.values.laborReqType.value,
    };
    return await postData(ROUTE_NAME, {
      data: dataToSend,
    });
  },
  patch: async ({ input }: { input: Scope }) => {
    const event = input.event as AnyEventObject;
    const dataToSend = {
      ...event.payload.values,
      endDate: event.payload.values.endDate || null,
      laborReqType: event.payload.values.laborReqType.value,
    };
    return await patchData(ROUTE_NAME, {
      pathParams: { id: event.payload.values.id?.toString() || '' },
      data: dataToSend,
    });
  },
};
